// extracted by mini-css-extract-plugin
module.exports = {"wrap":"KO","content":"LO","crumbsList":"MO","dropdownsWrap":"NO"};